import isEmpty from "lodash-es/isEmpty";

import { initApi } from "@/utils/api";
import { NetworkSignal, networkSignal } from "@/utils/signals";
import { Portfolio } from "@/api";

import { PortfolioDocument } from "../models";

type Store = {
  portfolio: NetworkSignal<Portfolio>["signal"];
};

type Actions = {
  fetch: (nickname: string | undefined) => Promise<Portfolio | undefined>;
};

export type UsePortfolio = Store & Actions;

const api = initApi();
const portfolio = networkSignal<Portfolio>({
  default: { title: "", description: "", documents: [] },
});

export function usePortfolio(): UsePortfolio {
  const fetch = async (nickname: string | undefined) => {
    return await portfolio.run(async () => {
      const portfolio = await GETPortfolio(nickname);
      portfolio.documents = sortDocuments(portfolio.documents);
      return portfolio;
    });
  };

  return {
    portfolio: portfolio.signal,
    fetch,
  };
}

async function GETPortfolio(nickname: string | undefined): Promise<Portfolio> {
  try {
    if (!isEmpty(nickname)) {
      return await api.getPublicPortfolio({ nickname: nickname! });
    }

    return await api.getPortfolio();
  } catch (error) {
    console.error(error);
    return { title: "", description: "", documents: [] };
  }
}

/**
 * Sorts portfolio documents by creation date in descending order, with undefined dates last
 * @param documents Array of portfolio documents to sort
 * @returns Sorted array of portfolio documents
 */
function sortDocuments(documents: PortfolioDocument[] | undefined): PortfolioDocument[] {
  if (!documents) return [];

  return documents.sort((a, b) => {
    if (!a.createdAt) return 1;
    if (!b.createdAt) return -1;

    return b.createdAt.getTime() - a.createdAt.getTime();
  });
}
